import { Observable } from 'rxjs';
import { Documents } from '../models/official-documents.model';

export abstract class OfficialDocumentsRepository {
    abstract storeDocuments(documentsData: Documents): Observable<boolean>;
}
